<template>
  <PageFiles />
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageFiles from '@theme/components/content/PageFiles'

const PAGE = {
  name: 'RouteFiles',
  nuxtI18n: {
    paths: {
      cs: '/soubory',
      de: '/dateien',
      en: '/files',
      sk: '/soubory',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageFiles,
  },
  mixins: [AppRouteMixin],
}
export default PAGE
</script>
